import $ from 'jquery';
import {
  Swiper, EffectFade, Navigation, Lazy, Pagination,
} from 'swiper';
import { getBreakpoints } from '../utils/utils';

const breakPoint = 990;
const swipers = [];
const swiperContainerClass = '.content-slider__container';

function refreshTabindex() {
  const $container = $('.swiper-slide a, .swiper-slide .c-expander__button-label');
  $container.attr('tabindex', -1);
  setTimeout(() => {
    const $containerActive = $('.swiper-slide-active a, .swiper-slide-active .c-expander__button-label');
    $containerActive.attr('tabindex', 0);
  }, 0);
}

function refreshExpander($slider) {
  const sh = $(window).width() < breakPoint;
  if (sh === true) {
    return;
  }
  let highestSlide = 0;
  const $slides = $slider.find('.content-slider__slide');
  const $excerpts = $slider.find('.content-slider__excerpt-wrapper');

  $excerpts.each(function () {
    const $curExcerpt = $(this);
    const $curExcerptContainer = $curExcerpt.closest('.content-slider__excerpt-container');
    const isUserExpanded = $curExcerptContainer.find('.c-expander__button-label').hasClass('expanded');

    if (!isUserExpanded) {
      $curExcerpt.removeClass('expanded');
      $curExcerpt.height('');
    }

    $curExcerpt.removeClass('content-slider__excerpt-wrapper--fits');
  });

  $slides.each(function () {
    if ($(this).height() > highestSlide) {
      highestSlide = $(this).height();
    }
  });
  $slides.each(function () {
    const $slideWrapper = $(this).find('.content-slider__excerpt-wrapper');
    const $slideWrapperInner = $(this).find('.content-slider__excerpt-wrapper-inner');
    const $slideReference = $(this).find('.content-slider__reference-container');
    const slideHeight = $slideWrapperInner.height() + $slideReference.height();

    if (slideHeight <= highestSlide) {
      $slideWrapper.addClass('content-slider__excerpt-wrapper--fits');
    }
  });
  $excerpts.each(function () {
    const $curExcerpt = $(this);
    const $curExcerptInner = $(this).find('.content-slider__excerpt-wrapper-inner');
    const $curExcerptContainer = $curExcerpt.closest('.content-slider__excerpt-container');
    const isUserExpanded = $curExcerptContainer.find('.c-expander__button-label').hasClass('expanded');

    const curExcerptInnerHeight = $curExcerptInner[0].scrollHeight;
    const curExcerptHeight = $curExcerpt.height();

    const isOverflowing = curExcerptInnerHeight > curExcerptHeight + 2
      && curExcerptInnerHeight > 0;

    if (isUserExpanded || isOverflowing) {
      $curExcerptContainer.find('.c-expander__button').show(); // refer to c-expander
      $curExcerptContainer.find('.c-expander__shadow').show(); // refer to c-expander
    } else {
      $curExcerptContainer.find('.c-expander__button').hide(); // refer to c-expander
      $curExcerptContainer.find('.c-expander__shadow').hide(); // refer to c-expander
    }
  });
}

function initSwiperContentSlider($slider) {
  const currentSlide = $slider.attr('current-slide') ? $slider.attr('current-slide') : 0;
  const swiper = new Swiper($slider[0], {
    effect: 'slide',
    lazy: {
      loadPrevNext: true,
    },
    spaceBetween: 45,
    autoHeight: $(window).width() < 992,
    loop: true,
    threshold: 15,
    initialSlide: currentSlide,
    navigation: {
      nextEl: $slider.find('.content-slider__arrow--next')[0],
      prevEl: $slider.find('.content-slider__arrow--prev')[0],
    },
    pagination: {
      clickable: true,
      el: '.content-slider__pagination',
    },
    modules: [EffectFade, Navigation, Lazy, Pagination],
    on: {
      init() {
        refreshTabindex();
      },
      slideChange() {
        refreshTabindex();
      },
      imagesReady() {
        refreshExpander($slider);
      },
      lazyImageReady() {
        refreshExpander($slider);
      },
    },
  });

  // Added keyboard navigation to swiper bullets
  $slider.find('.swiper-pagination-bullet').each(function (index) {
    const bullet = $(this);
    bullet.attr('id', (index));
  });

  $slider.find('.swiper-pagination').each(() => {
    $slider.find('.swiper-pagination-bullet').attr('tabindex', 0);
    $slider.find('.swiper-pagination-bullet').on('keydown', function (event) {
      if (event.keyCode === 13) {
        const slideID = $(this).attr('id');
        swiper.slideToLoop(slideID);
      }
    });
  });

  swipers.push(swiper);
}

function refreshPagination($slider) {
  if ($(window).width() < getBreakpoints().lg) {
    const pagination = $slider.find('.content-slider__nav-container .content-slider__pagination');
    const nav = $slider.find('.content-slider__nav');

    pagination.removeClass('content-slider__pagination--gray');
    nav.removeClass('position-absolute');
    pagination.addClass('content-slider__pagination--white position-absolute w-100 text-center');
    $slider.prepend(pagination);
  } else {
    const paginationContainer = $slider.find('.content-slider__nav-container');
    const pagination = $slider.find('.content-slider__pagination');
    pagination.removeClass('content-slider__pagination--white position-absolute w-100 text-center');
    paginationContainer.prepend(pagination);
  }
}

function init() {
  const $boxes = $(swiperContainerClass);
  $boxes.each(function () {
    const $slider = $(this);
    initSwiperContentSlider($slider);
    refreshPagination($slider);
    refreshExpander($slider);
  });
}

let lastWindowWidth = $(window).width();

window.addEventListener('resize', () => {
  const currentWidth = $(window).width();
  if (currentWidth !== lastWindowWidth) {
    lastWindowWidth = currentWidth;
    swipers.forEach((swiper) => {
      swiper.destroy();
      // eslint-disable-next-line no-param-reassign
      swiper = null;
    });
    swipers.length = 0;

    init();
  } else {
    const $boxes = $(swiperContainerClass);
    $boxes.each(function () {
      refreshExpander($(this));
    });
  }
});

function boot() {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=content-slider', ($block) => {
      initSwiperContentSlider($block.find(swiperContainerClass));
    });
  } else {
    init();
  }
}

// Delayed scripts execute after the window load event has already fired
if (document.readyState === 'complete') {
  boot();
} else {
  window.addEventListener('load', boot);
}
export default true;
